import type { MatTooltip } from '@angular/material/tooltip';

export const COPY_FEEDBACK_MS = 1500;

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  // Deferred: iOS Safari aborts download if revoked same task
  setTimeout(() => URL.revokeObjectURL(url));
}

export function copyWithFeedback(
  value: string,
  tooltip: Pick<MatTooltip, 'show'>,
  onCopied: (copied: boolean) => void,
  resetMs = COPY_FEEDBACK_MS,
): void {
  navigator.clipboard.writeText(value).then(() => {
    onCopied(true);
    tooltip.show();
    setTimeout(() => onCopied(false), resetMs);
  });
}

export function openSupportEmail(event: Event, email: string): void {
  event.preventDefault();
  window.open(`mailto:${email}`, '_blank', 'noopener,noreferrer');
}

export function reloadPage(): void {
  window.location.reload();
}

const STALE_CHUNK_RELOAD_KEY = 'staleChunkReloadAt';
const STALE_CHUNK_RELOAD_GUARD_MS = 10_000;
const STALE_CHUNK_MESSAGE =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

let staleChunkReloadStarted = false;

// Offline fails the same way
export function isStaleChunkError(error: unknown): boolean {
  return navigator.onLine && STALE_CHUNK_MESSAGE.test(error instanceof Error ? error.message : String(error ?? ''));
}

export function isStaleChunkReloadStarted(): boolean {
  return staleChunkReloadStarted;
}

// Rate-limited so a stale page cannot loop
export function reloadOnStaleChunk(
  error: unknown,
  url: string,
  location: Pick<Location, 'assign'> = window.location,
): boolean {
  if (!isStaleChunkError(error)) return false;
  try {
    if (Date.now() - Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) < STALE_CHUNK_RELOAD_GUARD_MS) return false;
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(Date.now()));
  } catch {
    return false;
  }
  staleChunkReloadStarted = true;
  location.assign(url);
  return true;
}
